import axios from "axios";
import { store } from "../store/store";
import appConfig from "../constants/AppConfig";
import Nprogress from "nprogress";

const api = {
	base: appConfig.host + "/api",
	request_api: async function(
		path_api,
		postData = new Object(),
		method = null
	) {
		return axios({
			url: this.base + path_api,
			method: method
				? method
				: Object["keys"](postData)["length"]
				? "POST"
				: "GET",
			data: postData,
			headers: {
				Authorization: "Bearer " + store.state.auth.token,
			},
		})
			.then((result) => {
				return { data: result.data, status: result.status };
			})
			.catch((error) => {
				console.log("request error");
				console.log(error);
				if (error.response) {
					if (
						error.response.status == 401 &&
						path_api != "/auth/refresh-token"
					) {
						swal.fire(
							"Thông báo",
							"Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại",
							"info"
						);
						store.dispatch("logoutUser");
						Nprogress.done();
					}
					return {
						...error.response.data,
						status: error.response.status,
					};
				}
			});
	},
	request_api_no_token: async function(path_api, postData = new Object()) {
		return axios({
			url: this.base + path_api,
			method: Object["keys"](postData)["length"] ? "POST" : "GET",
			data: postData,
		})
			.then((result) => {
				return { data: result.data, status: result.status };
			})
			.catch((error) => {
				console.log("request error");
				console.log(error);
				if (error.response) {
					return {
						...error.response.data,
						status: error.response.status,
					};
				}
			});
	},
	userLogin: function(username, password) {
		return this.request_api_no_token("/auth/login", { username, password });
	},
	createRoom: function(postData) {
		return this.request_api("/rooms", postData);
	},
	getListRoom: function() {
		return this.request_api("/rooms");
	},
	createDepositReceipt: function(postData) {
		return this.request_api("/deposits", postData);
	},
	getDepositReceipts: function(query) {
		return this.request_api(
			"/deposits/search" + (query ? "?" + query : "")
		);
	},
	getCheckInReceipt: function(query) {
		return this.request_api(
			"/check-ins/search" + (query ? "?" + query : "")
		);
	},
	createCheckInReceipt: function(postData) {
		return this.request_api("/check-ins", postData);
	},
	getListContracts: function(query) {
		return this.request_api(
			"/contracts/search" + (query ? "?" + query : "")
		);
	},
	getListCustomers: function() {
		return this.request_api("/customers");
	},
	searchCustomer: function(query) {
		return this.request_api(
			"/customers/search" + (query ? "?" + query : "")
		);
	},
	getRoomState: function(query) {
		return this.request_api(
			"/room-states/newest" + (query ? "?" + query : "")
		);
	},
	getDepositStatus: function(query) {
		return this.request_api(
			"/deposits/deposit-status" + (query ? "?" + query : "")
		);
	},
	getChargeRoom: function(query) {
		return this.request_api(
			"/general/charge-rooms/months" + (query ? "?" + query : "")
		);
	},
	createReceiptCollected: function(postData) {
		return this.request_api("/receipt-collected", postData);
	},
	createPaymentsRoom: function(postData) {
		return this.request_api("/payments", postData);
	},
	updatePayment: function(postData) {
		return this.request_api("/payments/update-payment", postData);
	},
	findPayment: function(query) {
		return this.request_api("/payments/find" + (query ? "?" + query : ""));
	},
	getReceiptNumberNewest: function(query) {
		return this.request_api(
			"/general/receipt-newest/search" + (query ? "?" + query : "")
		);
	},
	cancelDeposit: function(postData) {
		return this.request_api("/deposits/cancel", postData);
	},
	updateRoomState: function(postData) {
		return this.request_api("/room-states/update", postData);
	},
	getBills: function(query) {
		return this.request_api(
			"/bills/get-two-newest-bills" + (query ? "?" + query : "")
		);
	},
	createBills: function(postData) {
		return this.request_api("/bills/electric-water-count", postData);
	},
	createCheckOut: function(postData) {
		return this.request_api("/check-outs", postData);
	},
	getRoomDataForReturnDeposit: function(query) {
		return this.request_api(
			"/general/cash/deposit/search" + (query ? "?" + query : "")
		);
	},
	getListCheckOut: function(query) {
		return this.request_api(
			"/check-outs/search" + (query ? "?" + query : "")
		);
	},
	getListReturnDeposit: function(query) {
		return this.request_api(
			"/return-deposits/search" + (query ? "?" + query : "")
		);
	},
	createReceiptChange: function(postData) {
		return this.request_api("/receipt-changes", postData);
	},
	getReceiptChange: function(query) {
		return this.request_api(
			"/receipt-changes/search" + (query ? "?" + query : "")
		);
	},
	createReceiptRoom: function(postData) {
		return this.request_api("/receipt-rooms", postData);
	},
	getListReceiptRoom: function(query) {
		return this.request_api(
			"/receipt-rooms/search" + (query ? "?" + query : "")
		);
	},
	getListReceiptCollected: function(query) {
		return this.request_api(
			"/receipt-collected/search" + (query ? "?" + query : "")
		);
	},
	changeDeposit: function(postData) {
		return this.request_api("/deposits/transfer", postData);
	},
	cancelCheckOut: function(postData) {
		return this.request_api("/check-outs/cancel-check-out", postData);
	},
	getLogs: function(query) {
		return this.request_api("/logs" + (query ? "?" + query : ""));
	},
	getTwoNewestRoomStateEachRoom: function(query) {
		return this.request_api(
			"/room-states/two-newest-each-room" + (query ? "?" + query : "")
		);
	},
	refreshToken: function(postData) {
		return this.request_api("/auth/refresh-token", postData);
	},
	updateReceipt: function(api_route, postData) {
		return this.request_api(api_route, postData, "PUT");
	},
	createInternet: function(postData) {
		return this.request_api("/internet", postData);
	},
	getListInternet: function() {
		return this.request_api("/internet");
	},
	changeRoomIdInternet: function(postData) {
		return this.request_api("/internet/change-room-id", postData);
	},
	activateInternet: function(postData) {
		return this.request_api("/internet/activate", postData);
	},
	getListWallets: function() {
		return this.request_api("/wallet-account");
	},
	getListBvs: function() {
		return this.request_api("/users?role=SECURITY");
	},
	getChoTotTransaction: function(postData) {
		return this.request_api("/chotot/get-transactions", postData);
	},
	getListCollections: function() {
		return this.request_api("/admin/list-collection");
	},
	clearCollections: function(postData) {
		return this.request_api("/admin/clear-database", postData);
	},
	getDbInfo: function (){
		return this.request_api("/admin/db-info");
	},
	getRoomPayments: function(query) {
		return this.request_api(
			"/payments/search" + (query ? "?" + query : "")
		);
	},
	getReceiptDifference: function(query) {
		return this.request_api(
			"/difference-receipt" + (query ? "?" + query : "")
		);
	},
	editRoomPrice: function(postData) {
		return this.request_api("/general/increase-room", postData);
	},
	cancelInternetRoom: function(postData) {
		return this.request_api("/internet/cancel-internet-room", postData);
	},
	createDisbursementReceipt: function(postData) {
		return this.request_api("/disbursement", postData);
	},
	getDisbursementReceipt: function(query) {
		return this.request_api("/disbursement" + (query ? "?" + query : ""));
	},
	cutInternetRoom: function(postData) {
		return this.request_api("/internet/cut-internet", postData);
	},
	createReceiptOther: function(postData) {
		return this.request_api("/receipt-other", postData);
	},
	getReceiptRoomAndOther: function(query) {
		return this.request_api(
			"/general/receipt-room-and-other" + (query ? "?" + query : "")
		);
	},
	removeReceiptChange: function(postData) {
		return this.request_api("/receipt-changes/remove", postData);
	},
	removeCheckIn: function(postData) {
		return this.request_api("/check-ins/remove", postData);
	},
	getDevice: function(query) {
		return this.request_api(
			"/devices" + (query ? "?" + query : "")
		);
	},
	getCommission: function(query) {
		return this.request_api(
			"/commissions" + (query ? "?" + query : "")
		);
	},
	removeReceiptRoom: function(postData) {
		return this.request_api("/receipt-rooms/remove", postData);
	},
	getBillsForCheckIn: function(query) {
		return this.request_api(
			"/bills/get-bills-for-check-in" + (query ? "?" + query : "")
		);
	},
	getBillForAudit: function (query) {
		return this.request_api(
			"/bills/audit-data" + (query ? "?" + query : "")
		);
	}
};
export default api;
